import React, { useState, Fragment, useEffect } from "react";
//import Multistep from "react-multistep";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import {
    GetActiveBarbers,
	GetServicesByBarberId,
	GetServiceDurations,
	GetTermsAndConditions,
	GetBarberWorkingDays,
	GetAvailableTimesForBarberByDateTime,
	GetServices,
	AcceptingPaymentsStatus,
	GetTheme,
	GetStripeAccountRequirmentsState,
	GetAccountStatus
} from './Requests';
import { Trans, useTranslation } from "react-i18next";
import Typography from '@mui/material/Typography';
import { ConstructionOutlined } from "@mui/icons-material";
import './MakeBooking.css'
// import './MakeBooking2.css'
import {
  Elements,
} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const MakeBooking = () => {
	const { t, i18n } = useTranslation("makeBooking");
  	const { t: a } = useTranslation("auth");
    const [goSteps, setGoSteps] = useState(0);
	const [bookingResult, setBookingResult] = useState(false)
    const [barberData, setBarberData] = useState('waiting');
	const [email, setEmail] = useState();
	const [barberRawData, setBarberRawData] = useState(null);
	const [lang, setLang] = useState("en-GB")
	const queryParameters = new URLSearchParams(window.location.search)
	const barberShopIdFromUrlParam = queryParameters.get("id")
	const [barberShopId, setBarberShopId] = useState(barberShopIdFromUrlParam)
	const [selectedBarber, setSelectedBarber] = useState()
	const [selectedService, setSelectedService] = useState()
	const [services, setServices] = useState('waiting')
	const [availableTimes, setAvailableTime] = useState('waiting')
	const [serviceDurations, setServiceDurations] = useState()
	const [barberWorkingDays, setBarberWorkingDays] = useState()
	const [selectedDate, setSelectedDate] = useState()
	const [selectedTime, setSelectedTime] = useState()
	const [selectedTimeId, setSelectedTimeId] = useState()
	const [firstName, setFirstName] = useState()
	const [lastName, setLastName] = useState()
	const [mobile, setMobile] = useState()
	const [acceptingOnlinePayments, setAcceptingOnlinePayments] = useState()
	const [theme, setTheme] = useState(null)
	const [requirements, setRequirements] = useState()
	const [isBookingPortalAvailable, setIsBookingPortalAvailable] = useState()
	const [currency, setCurrency] = useState()
	const [shopName, setShopName] = useState()
	const [shopEmail, setShopEmail] = useState()
	const [terms, setTerms] = useState()
	const [appointmentNotes, setAppointmentNotes] = useState()
	const [appointmentCancellationMessage, setAppointmentCancellationMessage] = useState()
	const [website, setWebsite] = useState()
	const [emailForCustomer, setEmailForCustomer] = useState()
	const [phoneNumbeForCustomer, setPhoneNumberForCustomer] = useState()
	const [addressNameNumber, setAddressNameNumber] = useState()
	const [addressFirstLine, setAddressFirstLine] = useState()
	const [addressSecondLine, setAddressSecondLine] = useState()
	const [addressCity, setAddressCity] = useState()
	const [addressCounty, setAddressCounty] = useState()
	const [addressPostcode, setAddressPostcode] = useState()
	const [mapUrl, setMapUrl] = useState()
	const [shopNotFound, setShopNotFound] = useState(false)
  	const supported = (i18n.options?.supportedLngs || ['en', 'es']).filter(l => l !== 'cimode');
	const [acceptBookings, setAcceptBookings] = useState(false);
	useEffect(() => {
		if (barberShopId !== null)
		{
			// GetAccountStatusWrapper()
			GetAccountStatus(barberShopId).then((res) => {
				if (res.data === true)
				{
					setAcceptBookings(true)
					GetServiceDurationsWrapper()
					GetServicesWrapper()
					GetAcceptingPayementStatusWrapper()
					GetTermsAndConditionsWrapper()
					GetStripeAccountRequirmentsStateWrapper()
				} else {
					GetThemeWrapper()
					setAcceptBookings(false)

				}
			}).catch((error) => {
				console.log(error.status)
				if (error.status === 400)
				{
					setShopNotFound(true)
				}
				setAcceptBookings(false)
				
			})
		}

	}, []);

	function GetBarberWorkingDaysWrapper(barberId) {
		setBarberWorkingDays(null)
		GetBarberWorkingDays(barberId, barberShopId).then((res) => {
			setBarberWorkingDays(res.data)
		}).catch((error) => {
		})
	}

	function GetAcceptingPayementStatusWrapper()
	{
		AcceptingPaymentsStatus(barberShopId).then((res) => {
			setAcceptingOnlinePayments(res.data)
		}).catch((error) => {
		})
	}

	  function GetTermsAndConditionsWrapper() {
    GetTermsAndConditions(barberShopId).then((res) => {
      setTerms(res.data[0])
	  setAppointmentNotes(res.data[1])
	  setAppointmentCancellationMessage(res.data[2])
	  setWebsite(res.data[3])
	  setEmailForCustomer(res.data[4])
	  setPhoneNumberForCustomer(res.data[5])
	  setAddressNameNumber(res.data[6])
	  setAddressFirstLine(res.data[7])
	  setAddressSecondLine(res.data[8])
	  setAddressCity(res.data[9])
	  setAddressCounty(res.data[10])
	  setAddressPostcode(res.data[11])
	  if(res.data[11] !== null)
	  {
		setMapUrl('https://www.google.com/maps/search/?api=1&query='+res.data[6]+" "+res.data[7]+" "+res.data[8] +" "+ res.data[11])
	  }

    }).catch((error) => {
    }).finally(() => {
    })
  }

  
	  function GetThemeWrapper() {
    GetTheme(barberShopId).then((res) => {
      setTheme(res.data)

    }).catch((error) => {
    }).finally(() => {
    })
  }

function GetStripeAccountRequirmentsStateWrapper() {
    GetStripeAccountRequirmentsState(barberShopId).then((res) => {
      setRequirements(res.data.requirements)
	  setCurrency(res.data.currency)
	  setShopName(res.data.shopName)
	  setIsBookingPortalAvailable(res.data.isBookingPortalAvailable)
	  document.title = res.data.shopName
	  setLang(res.data.bookingPortalLanguage)
	  i18n.changeLanguage(res.data.bookingPortalLanguage)
    }).catch((error) => {
    }).finally(() => {
		GetThemeWrapper()
    })
  }


	function GetAvailableTimesForBarberByDateTimeWrapper(date) {
		setAvailableTime('waiting')
		setSelectedDate(date)
		GetAvailableTimesForBarberByDateTime(selectedBarber.barberId, date, selectedService.serviceId, barberShopId).then((res) => {
			if (res.data.length === 0)
			{
				setAvailableTime(null)
			}
			else
			{
				setAvailableTime(res.data)
			}
		}).catch((error) => {
		})
	}
	function GetBarbersWrapper(service) {
		GetActiveBarbers(barberShopId).then((res) => {
			var obj = {key:service.name, value: 1}
			var ids = []
			res.data.forEach(barber => {
				barber.serviceNames.forEach(row => {
					if (JSON.stringify(row) == JSON.stringify(obj))
					{
						ids.push(barber.barberId)
					}
				});
			});
			var data = []
			var filteredBarbers = res.data.filter(x => ids.includes(x.barberId))
			filteredBarbers.forEach(element => {
				var returnData = createData(element.barberId, element.name, element.filename, element.imageFile, element.serviceNames, element.status, element.sunday, element.monday, element.tuesday, element.wednesday, element.thursday, element.friday, element.saturday, element.barberColour)
				data.push(returnData)
			});
			setBarberData(data)
			setBarberRawData(res.data);
		}).catch((error) => {
		})
	}

	function GetServicesWrapper() {
		GetServices(barberShopId).then((res) => {
			
			if (res.data.length === 0)
				{
					setServices(null)
				}
				else
				{
					setServices(res.data)
				}
		}).catch((error) => {
		})
	}

	function GetServiceDurationsWrapper() {
		setServiceDurations(null)
		GetServiceDurations(barberShopId).then((res) => {
			setServiceDurations(res.data)
		}).catch((error) => {
		})
	}

	function createData(barberId, name, filename, image, serviceNames, status, sunday, monday, tuesday, wednesday, thursday, friday, saturday, barberColour) {
		var daysArray = [sunday, monday, tuesday, wednesday, thursday, friday, saturday]
		const buildArray = [];
		for (var i=0; i < daysArray.length; i++) {
			var obj = {day: daysArray[i], serviceNames: { serviceName :serviceNames[i] === undefined ? "" : serviceNames[i].key, status: serviceNames[i] === undefined ? "" : serviceNames[i].value}}
			buildArray.push(obj)
		}
		return {
		barberId,
		name,
		filename,
		image,
		status,
		barberColour,
		history: buildArray,
		};
	}

	function handleBarberSelected(barber) {
		setSelectedBarber(barber);
	  }



	    const serviceName = selectedService?.name ?? "Service";
  const staffName = selectedBarber?.name ?? "Team member";

  const hasNotes = !!appointmentNotes?.trim();
  const hasCancellation = !!appointmentCancellationMessage?.trim();

  const hasAddress = [
    addressNameNumber,
    addressFirstLine,
    addressSecondLine,
    addressCity,
    addressCounty,
    addressPostcode,
  ].some(Boolean);

  const contactEmail = emailForCustomer || null;
  const contactPhone = phoneNumbeForCustomer || null;

  // Format date nicely if selectedDate is a Date or ISO string
  const dateObj =
    selectedDate instanceof Date ? selectedDate : new Date(selectedDate);
  const friendlyDate = isNaN(dateObj)
    ? String(selectedDate)
    : new Intl.DateTimeFormat(undefined, {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(dateObj);

	  
    return (
		
		<div data-theme={theme === 1 ? "one": theme === 2 ? "two" : "one"}>
{console.log(acceptBookings)}
			{theme !== null
			?
        <div
		className="booking-portal-background"
		 style={{
			minHeight:"100vh"
			}}>
			{
			!isBookingPortalAvailable ?
			  <div className="cancel-appointment-container">
				<div className="cancel-appointment-card" style={{ marginTop: "2rem", marginBottom: "2rem" }}>
				<div>
					<div className="icon-problem-wrapper">
					<span className="problem-icon" aria-hidden="true">&#x2718;</span>
					</div>
					<h1>{t("appointmentFailed.titles.heading")}</h1>
					<p>{t("appointmentFailed.error.BookingPortalOffline")}</p>
				</div>
				</div>
			</div>
			:
			bookingResult === false && acceptBookings ?
						<div className="row">
						<div className="col-xl-12 col-xxl-12">
							<div className="">
								<div className="">
									<div className="form-wizard ">
          <div style={{display:"flex", justifyContent:"flex-end"}}>
            <label htmlFor="lang-switch" className="visually-hidden">
              {t('login.lang.ariaLabel')}
            </label>
                <div className="centered-select">
            </div>
            <select
              id="lang-switch"
              value={lang}
              onChange={(e) => {i18n.changeLanguage(e.target.value); setLang(e.target.value);}}
              aria-label={t('login.lang.ariaLabel')}
              className="lang-select"
              style={{
                
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #ddd',
                background: '#fff'
              }}
            >
              {supported.map(code => (
                <option key={code} value={code}>
                  {a(`login.lang.names.${code}`, code.toUpperCase())}
                </option>
              ))}
            </select>
          </div>

									{goSteps === 0 && (
										<>
											<StepOne currency={currency} theme={theme} acceptingOnlinePayments={acceptingOnlinePayments} handleServiceSelected={setSelectedService} goTo={setGoSteps} services={services} serviceDurations={serviceDurations} getBarbers={GetBarbersWrapper}/>
										</>
									)}
									{goSteps === 1 && (
										<>
											<StepTwo theme={theme} handleBarberSelected={setSelectedBarber} goTo={setGoSteps} getBarberWorkingDays={GetBarberWorkingDaysWrapper} barbers={barberData} setBarberData={setBarberData} />	
										</>
									)}
									{goSteps === 2 && (
										<>
										{barberWorkingDays !== null ?
											<StepThree theme={theme} barberWorkingDays={barberWorkingDays} defaultDate={selectedDate} queryDate={GetAvailableTimesForBarberByDateTimeWrapper} selectTimeId={setSelectedTimeId} selectTime={setSelectedTime} goTo={setGoSteps} availableTimes={availableTimes} setAvailableTime={setAvailableTime}/>
											:
											<></>
										}
										</>
									)}
									{goSteps === 3 && (
										<>
											<StepFour currency={currency} lang={lang} emailForCustomer={emailForCustomer} shopName={shopName} serviceDurations={serviceDurations} requirements={requirements} theme={theme} terms={terms} acceptingOnlinePayments={acceptingOnlinePayments} setEmail={setEmail} setFirstName={setFirstName} setLastName={setLastName} setMobile={setMobile} bookingResult={setBookingResult} goTo={setGoSteps} service={selectedService} barber={selectedBarber} date={selectedDate} time={selectedTime} timeId={selectedTimeId}/>
										</>	
									)}
									{goSteps === 4 && (
										<>
											<StepFive currency={currency} theme={theme} goTo={setGoSteps} service={selectedService} bookingResult={setBookingResult} firstName={firstName} lastName={lastName} email={email} mobile={mobile} timeId={selectedTimeId} date={selectedDate} time={selectedTime} barber={selectedBarber}/>
										</>	
									)}
									
									</div>
								</div>
							</div>
						</div>
					</div> 
			
			:
			!acceptBookings ?
			  <div className="cancel-appointment-container">
				<div className="cancel-appointment-card" style={{ marginTop: "2rem", marginBottom: "2rem" }}>
				<div>
					<div className="icon-problem-wrapper">
					<span className="problem-icon" aria-hidden="true">&#x2718;</span>
					</div>
					<h1>{t("appointmentFailed.titles.heading")}</h1>
					<p>{t("appointmentFailed.error.bookingNotAllowed")}</p>
				</div>
				</div>
			</div>
			:
			bookingResult === 'success'
			?
  <div className="cancel-appointment-container p-2">
      <div className="confirm__card">
        <div className="confirm__header">

          <div className="confirm__titles">
            <h1 className="confirm__title">
              {t("appointmentConfirmation.titles.booked")}
            </h1>
            <p className="confirm__subtitle">
              <Trans
                i18nKey="appointmentConfirmation.subtitles.confirmationSent"
                ns="makeBooking"
                values={{ email }}
                components={{ b: <b /> }}
              />
            </p>
          </div>
		            <div className="confirm__icon" aria-hidden="true">
            <span className="check-icon">&#10003;</span>
          </div>
        </div>

        {/* Summary */}
        <div className="summaryTiles">
          <h3 className="summaryTitle">
            {t("appointmentConfirmation.titles.summary")}
          </h3>

          <ul className="tiles">
            <li className="tile">
              <span className="tileLabel">
                {t("appointmentConfirmation.labels.service")}
              </span>
              <span className="tileValue tileClamp">{selectedService?.name}</span>
            </li>

            <li className="tile">
              <span className="tileLabel">
                {t("appointmentConfirmation.labels.with")}
              </span>
              <span className="tileValue tileClamp">{selectedBarber?.name}</span>
            </li>

            <li className="tile">
              <span className="tileLabel">
                {t("appointmentConfirmation.labels.date")}
              </span>
				<span className="tileValue tileNowrap">
                {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short", year: "numeric" })
                  .format(selectedDate).replace(/,/g, "")}
              </span>
            </li>

            <li className="tile">
              <span className="tileLabel">
                {t("appointmentConfirmation.labels.time")}
              </span>
              <span className="tileValue tileMono">{selectedTime}</span>
            </li>
          </ul>
        </div>

        {/* Notes (optional) */}
        {hasNotes && (
          <div className="confirm__section">
            <h4 className="confirm__h4">
              {t("appointmentConfirmation.titles.notes")}
            </h4>
            <p className="confirm__text">{appointmentNotes}</p>
          </div>
        )}

        {/* Cancellation policy (optional) */}
        {hasCancellation && (
          <div className="confirm__section">
            <h4 className="confirm__h4">
              {t("appointmentConfirmation.titles.cancellationPolicy")}
            </h4>
            <p className="confirm__text">{appointmentCancellationMessage}</p>
          </div>
        )}

        {/* Location + Contact */}
        {(hasAddress || website || contactEmail || contactPhone) && (
          <div className="confirm__grid">
            {hasAddress && (
              <div className="confirm__panel">
                <h4 className="confirm__h4">
                  {t("appointmentConfirmation.titles.location")}
                </h4>
                <address className="confirm__address">
                  {addressNameNumber && <span>{addressNameNumber}, </span>}
                  {addressFirstLine && <span>{addressFirstLine}, </span>}
                  {addressSecondLine && <span>{addressSecondLine}, </span>}
                  {addressCity && <span>{addressCity}, </span>}
                  {addressCounty && <span>{addressCounty}, </span>}
                  {addressPostcode && <span>{addressPostcode}</span>}
                </address>

                {mapUrl && (
                  <a
                    className="confirm__link"
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("appointmentConfirmation.actions.getDirections")}
                  </a>
                )}
              </div>
            )}

            {(website || contactEmail || contactPhone) && (
              <div className="confirm__panel">
                <h4 className="confirm__h4">
                  {t("appointmentConfirmation.titles.contact")}
                </h4>

				{website && !/^https?:\/\/$/i.test(website.trim()) && (
				<p className="confirm__text">
					<a
					className="confirm__link"
					href={website}
					target="_blank"
					rel="noopener noreferrer"
					>
					{website}
					</a>
				</p>
				)}

                {contactEmail && (
                  <p className="confirm__text">
                    <a className="confirm__link" href={`mailto:${contactEmail}`}>
                      {contactEmail}
                    </a>
                  </p>
                )}

                {contactPhone && (
                  <p className="confirm__text">
                    <a className="confirm__link" href={`tel:${contactPhone}`}>
                      {contactPhone}
                    </a>
                  </p>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
			:
			bookingResult === 'failed'
			?
  <div className="cancel-appointment-container">
    <div className="cancel-appointment-card" style={{ marginTop: "2rem", marginBottom: "2rem" }}>
      <div>
        <div className="icon-problem-wrapper">
          <span className="problem-icon" aria-hidden="true">&#x2718;</span>
        </div>
        <h1>{t("appointmentFailed.titles.heading")}</h1>
        <p>{t("appointmentFailed.messages.body")}</p>
        <div className="confirm__actions">
		<button
		type="button"
		className="select-btn mt-3"
		style={{marginLeft:"auto", marginRight:"auto"}}
		onClick={() => window.location.href = `make-a-booking?id=${barberShopId}`}
		>
		{t("appointmentFailed.actions.tryAgain")}
		</button>
          {/* <a className="confirm__link" href="/support">
            {t("appointmentFailed.actions.contactUs")}
          </a> */}
        </div>
      </div>
    </div>
  </div>
			:
			<div></div>
			}
        </div>
:
 shopNotFound ?
<>
        <div
		className="booking-portal-background"
		 style={{
			minHeight:"100vh"
			}}>
			  <div className="cancel-appointment-container">
				<div className="cancel-appointment-card" style={{ marginTop: "2rem", marginBottom: "2rem" }}>
				<div>
					<div className="icon-problem-wrapper">
					<span className="problem-icon" aria-hidden="true">&#x2718;</span>
					</div>
					<h1>{t("appointmentFailed.titles.heading")}</h1>
					<p>{t("appointmentFailed.error.BookingPortalShopNotFound")}</p>
				</div>
				</div>
			</div>
			</div>
</>
:
null
			}
			

		</div>
    );
}

export default MakeBooking;